// extracted by mini-css-extract-plugin
export default {"icon":"PomodoroIconButton_icon__iJgsz"};